import {defineStore} from "pinia";
import {Ref, ref, watch} from "vue";
import {IChat, IPanel, IPanelKey} from "@/features/chat/chat.types";
import router from "@/router";
import {ITableHeader, ITableItem} from "@/types/table";
import {IFilter} from "@/types/main";
import {IProfile} from "@/features/auth/auth.types";
import {authService} from "@/features/auth/auth.service";
import {chatService} from "@/features/chat/chat.service";
import {DateTime} from "luxon";
import {useAppStore} from "@/store/app.store";

export const useChatStore = defineStore("chat", () => {
    const headers: ITableHeader[] = [
        {
            name: "id",
            label: "No",
            fitContent: true
        },
        {
            name: "title",
            label: "Users",
            width: "300px",
        },
        {
            name: "session_name",
            label: "Account",
        },
        {
            name: "all",
            label: "All messages",
            panel: ["allMessages"]
        },
        {
            name: "text",
            label: "Text",
            panel: ["allMessages", "text"]
        },
        {
            name: "voice",
            label: "Voice & Document",
            panel: ["allMessages", "voice"]
        },
        {
            name: "call",
            label: "Call",
            panel: ["allMessages", "call"]
        },
        {
            name: "photo",
            label: "Photo & Video",
            panel: ["allMessages", "photo"]
        },
        {
            name: "all_errors",
            label: "All errors",
            type: "error",
            panel: ["allMessages", "allErrors"]
        },
        {
            name: "reply_time",
            label: "Reply Time",
            type: "error",
            panel: ["allMessages", "replyTime"]
        },
        {
            name: "unanswered",
            label: "Unanswered",
            type: "error",
            panel: ["allMessages", "unanswered"]
        },
        {
            name: "deleted",
            label: "Deleted",
            type: "error",
            panel: ["allMessages", "deleted"]
        },
        {
            name: "edited",
            label: "Edited",
            type: "error",
            panel: ["allMessages", "edited"]
        },
    ];

    const commonFilter = ref<IFilter>({
        q: '',
        date_from: '',
        date_to: '',
        time_from: '',
        time_to: '',
        shift_id: 0,
        account: 0,
        outgoing: null,
        fuzzy: true,
        fuzzy_threshold: 0.3,
        page: 1,
        page_size: 50,
        include_photo_base64: false
    })

    async function getChats(loading: Ref) {
        if (loading.value) {
            return
        } else {
            try {
                loading.value = true
                let newFilter = {...commonFilter.value};
                if (newFilter.q.length == 0) {
                    delete newFilter.fuzzy
                    delete newFilter.fuzzy_threshold
                }
                const {data} = await chatService.getPersonalChats(newFilter);
                return data
            } finally {
                loading.value = false
            }
        }
    }

    return {headers, commonFilter, getChats};
});
